export const statuses = [
  {id: 7, value: '--NONE--', color: 'white'},
  {id: 1, value: 'zone_1', color: 'orange'},
  {id: 2, value: 'zone_2', color: 'red'},
  {id: 3, value: 'zone_3', color: 'blue'},
  {id: 4, value: 'zone_4', color: 'green'},
  {id: 5, value: 'zone_5', color: 'purple'},

];